export default __webpack_public_path__ + "static/mobile_dock_m-82646c47903bdc4e8be0ad908a9d155e.png";